export function handleGetContentSuccess(action, response) {
  const convertedData = response.map(c => ({
    id: c.id,
    createdDate: c.updatedDate,
    key: c.name,
    name: c.description,
  }));
  action.onSuccess(convertedData, response.total);
}
